import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const CommentsContent = lazy(() => import('../../components/Pages/Comments'));

export default function Comments(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Comments page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <CommentsContent />
      </Suspense>
    </Layout>
  );
}
